import { Component, OnInit } from '@angular/core';
import { NavigationService } from './shared/services/navigation.service';
import * as AOS from 'aos';
import { PrimeNGConfig } from 'primeng/api';
import { environment } from 'src/environments/environment';
import constants from 'src/config/constants';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit {
  environment = environment;

  constructor(
    navigation: NavigationService,
    private config: PrimeNGConfig
  ){
    navigation.startSaveHistory();
  }

  ngOnInit(): void {
    AOS.init();
    window.addEventListener('load', AOS.refresh);

    this.config.setTranslation({
      apply: 'Aplicar',
      clear: 'Borrar'
    });
  }

  getEnvironmentColor() {
    if(environment.configuration === constants.envRelease) {
      return constants.colorRelease;
    }
    
    return constants.colorDevelop;
  }
}
